module.exports = __webpack_public_path__ + "static/media/Enigma Bureau.995336fe.png";